import _ from 'lodash';
import { CardRewardsEarnRates } from '../data/types/CardRewardsEarnRates';
import { Modal } from './design-system/Modal';
import { formatSpendCategory } from '../data/shared/utils/formatSpendCategory';
import { EditableTableCell } from './design-system/EditableTableCell';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRefresh } from '@fortawesome/free-solid-svg-icons';


function isValidElementToRender(value: unknown) {
  return !(typeof value === 'object');
}

/**
 * Recursively calls render into a list of divs
 */

function treeTraversalRenderHOF<T>(
  renderFn: (value: T, key: string) => JSX.Element,
  isValid = isValidElementToRender
) {
  const fn = (mapping: Record<string, unknown>, prefix = '') => {
    return Object.entries(mapping).flatMap(
      ([key, value]): JSX.Element[] => {
        const currKey = prefix ? `${prefix}.${key}` : key;

        if (!isValid(value)) {
          // Recursively handle nested categories
          return fn(value as Record<string, unknown>, currKey);
        } else {
          // Return a single element for non-nested categories
          return [renderFn(value as T, currKey)];
        }
      }
    );
  };
  return fn;
}


export const EditMonthlySpend = ({
  monthlySpend,
  setMonthlySpend,
  resetMonthlySpend,
  handleClose,
}: {
  monthlySpend: CardRewardsEarnRates;
  setMonthlySpend: (
    _:
      | CardRewardsEarnRates
      | ((prev: CardRewardsEarnRates) => CardRewardsEarnRates)
  ) => void;
  resetMonthlySpend: (_?: string) => void;
  handleClose: () => void;
}) => {
  const renderSpendInputs = treeTraversalRenderHOF(
    (value: number, key: string) => (
      <div key={key} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
        <label style={{ marginRight: 10}} htmlFor={key}>{formatSpendCategory(key)}</label>
        <EditableTableCell
          prefix="$"
          value={String(value)}
          onChange={(value) =>
            setMonthlySpend((prev) => {
              return _.set({ ...prev }, key, Number(value));
            })
          }
        />
      </div>
    )
  );

  return (
    <Modal isOpen={true} handleClose={handleClose}>
      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' , alignItems: 'center'}}>
      <h1>Edit monthly spend</h1>
      <button onClick={() => resetMonthlySpend()}>
        <FontAwesomeIcon icon={faRefresh} />{' '}
        Reset spend
      </button>
      </div>
      {renderSpendInputs(monthlySpend)}
    </Modal>
  );
};
